(function () {
  if (window.__AG_PB_REASONS_INIT__) return;
  window.__AG_PB_REASONS_INIT__ = true;

  function getSteps(root) {
    return Array.prototype.slice.call(root.querySelectorAll('.js-ag-pb-reasons-step'));
  }

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function updateProgress(root) {
    var steps = getSteps(root);
    var fill = root.querySelector('.js-ag-pb-reasons-fill');
    var track = root.querySelector('.ag-pb-reasons__track');
    if (!fill || !track || steps.length === 0) return;

    var nums = steps.map(function (step) {
      return step.querySelector('.ag-pb-reasons-step__num');
    }).filter(Boolean);

    if (nums.length === 0) return;

    var timeline = root.querySelector('.ag-pb-reasons__timeline');
    if (!timeline) return;

    var timelineRect = timeline.getBoundingClientRect();
    var firstNumRect = nums[0].getBoundingClientRect();
    var lastNumRect = nums[nums.length - 1].getBoundingClientRect();
    var firstCenter = firstNumRect.top + firstNumRect.height / 2;
    var lastCenter = lastNumRect.top + lastNumRect.height / 2;
    var trackSpan = Math.max(0, lastCenter - firstCenter);

    track.style.top = Math.max(0, firstCenter - timelineRect.top) + 'px';
    track.style.bottom = 'auto';
    track.style.height = trackSpan + 'px';

    var triggerY = window.innerHeight * 0.55;
    var activeIndex = 0;

    steps.forEach(function (step, index) {
      var rect = step.getBoundingClientRect();
      if (rect.top <= triggerY) activeIndex = index;
    });

    if (prefersReducedMotion()) {
      activeIndex = steps.length - 1;
    }

    steps.forEach(function (step, index) {
      step.classList.toggle('is-filled', index <= activeIndex);
    });

    var activeNumRect = nums[activeIndex].getBoundingClientRect();
    var activeCenter = activeNumRect.top + activeNumRect.height / 2;
    var fillHeight = Math.max(0, Math.min(trackSpan, activeCenter - firstCenter));

    fill.style.top = '0px';
    fill.style.height = fillHeight + 'px';
  }

  function initBlock(root) {
    if (root.dataset.agPbReasonsReady === 'true') return;
    root.dataset.agPbReasonsReady = 'true';

    var ticking = false;

    function onScrollOrResize() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        updateProgress(root);
        ticking = false;
      });
    }

    updateProgress(root);
    requestAnimationFrame(function () {
      updateProgress(root);
    });

    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize, { passive: true });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function () {
        onScrollOrResize();
      }, {
        root: null,
        threshold: [0, 0.25, 0.5, 0.75, 1]
      });

      getSteps(root).forEach(function (step) {
        observer.observe(step);
      });
      observer.observe(root);
    }
  }

  function initAll() {
    document.querySelectorAll('.js-ag-pb-reasons').forEach(initBlock);
  }

  function resetAll() {
    document.querySelectorAll('.js-ag-pb-reasons').forEach(function (root) {
      delete root.dataset.agPbReasonsReady;
    });
    initAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', resetAll);
  document.addEventListener('shopify:block:select', resetAll);
})();
